import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Security, useOktaAuth } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import Cookies from 'js-cookie';

import config from 'config';

const oktaAuth = new OktaAuth({
  issuer: 'https://missionlane.okta.com/oauth2/aus8t9fhmb0ggdhir357',
  clientId: config.OKTA_CLIENT_ID,
  redirectUri: config.OKTA_REDIRECT_URI,
  pkce: true,
});

// Need this abstracted into a secondary component because Security provides authState to useOktaAuth
export const TokenManagementWrapper = ({ children }) => {
  const { authState } = useOktaAuth();

  useEffect(
    function storeOktaTokenInCookies() {
      if (authState) {
        const { idToken, isAuthenticated, isPending } = authState;
        if (idToken && isAuthenticated && !isPending) {
          Cookies.set('id_token', idToken.idToken, {
            domain: config.GQL_COOKIE_DOMAIN,
            sameSite: 'None',
            secure: true,
          });
          localStorage.setItem('id_token', idToken.idToken);
        }
      }
    },
    [authState],
  );

  return children;
};

const OktaAuthenticationProvider = ({ children }) => {
  const navigate = useNavigate();
  const restoreOriginalUri = useCallback(
    async (_oktaAuth, originalUri) => {
      navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
        replace: true,
      });
    },
    [navigate],
  );

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <TokenManagementWrapper>{children}</TokenManagementWrapper>
    </Security>
  );
};

export default OktaAuthenticationProvider;
